import React from 'react';

import { AgentChatPanel } from '~/components/AgentChat/AgentChatPanel';
import { useSysconfig } from '~/components/SystemConfiguration/SystemConfigurationScreen';

import { ASSISTANT_PRESENTATION } from './texts';

/** The Configuration Assistant: a staff chat whose turns claims-ai answers through the configuration MCP. */
const ConfigurationAssistantTab: React.FC = () => {
  // @ts-expect-error TODO: useSysconfig hook needs TypeScript definition
  const { organization } = useSysconfig();

  return (
    <AgentChatPanel
      organizationId={organization.id}
      agentKey="configuration_assistant"
      presentation={ASSISTANT_PRESENTATION}
    />
  );
};

export default ConfigurationAssistantTab;
